import { render, staticRenderFns } from "./RecognitionsFilters.vue?vue&type=template&id=0d5ee871"
import script from "./RecognitionsFilters.vue?vue&type=script&lang=js"
export * from "./RecognitionsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports